module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Regular-webfont.ttf
// module id = 1611
// module chunks = 0